import React from 'react'
import moment from 'moment'
import { FC, MouseEvent } from 'react'
import styles from './style.module.scss'

interface DayHeaderProps {
  date: Date
  isToday: boolean
  onDoubleClick: (e: MouseEvent<HTMLDivElement>) => void
}

const DayHeader: FC<DayHeaderProps> = ({ date, isToday, onDoubleClick }) => {
  // 날짜 포맷팅
  const formattedDate = moment(date)
  const dayNumber = formattedDate.format('D')
  const dayName = formattedDate.format('dddd')

  return (
    <div className={styles.dayHeader} onDoubleClick={onDoubleClick}>
      <div className={isToday ? styles.todayNumber : styles.dayNumber}>{dayNumber}</div>
      <div className={isToday ? styles.todayName : styles.dayName}>{dayName}</div>
    </div>
  )
}

export default DayHeader
